import React, { useState } from "react";
import { useData } from "../../../context/DataContext";
import ImageUploadField from "../../../utils/ImageUploadField";
import { successToast, errorToast } from "../../../utils/dialog";

const AboutVideoAdmin = () => {
  const { aboutVideo, updateAboutVideo } = useData();

  const [formData, setFormData] = useState({
    heading: aboutVideo.heading || "",
    subheading: aboutVideo.subheading || "",
    videoUrl: aboutVideo.videoUrl || "",
  });
  const [videoFile, setVideoFile] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setVideoFile(file);
      const previewUrl = URL.createObjectURL(file);
      setFormData((prev) => ({ ...prev, videoUrl: previewUrl }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await updateAboutVideo(formData, videoFile);
      successToast("Hero Video section updated.");
    } catch (err) {
      console.error(err);
      errorToast("Error updating Hero Video section.");
    }
  };

  return (
    <div className="p-6 space-y-8">
      <h2 className="text-3xl font-bold mb-4 text-gray-800">Hero Video Admin Panel</h2>

      {/* Form */}
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow space-y-4">
        <h3 className="text-2xl font-semibold text-gray-700 mb-4">Update Section</h3>
        <input
          name="heading"
          value={formData.heading}
          onChange={handleInputChange}
          placeholder="Heading"
          className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-400"
        />
        <input
          name="subheading"
          value={formData.subheading}
          onChange={handleInputChange}
          placeholder="Subheading"
          className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-400"
        />
        <ImageUploadField
          label="Hero Video"
          hint="Recommended size: 1920×1080px (16:9). Accepts video files."
          aspect="wide"
          accept="video/*"
          buttonLabel={videoFile ? "Change Video" : "Upload Video"}
          previewUrl={formData.videoUrl}
          file={videoFile}
          onChange={handleFileChange}
          onClear={() => {
            setVideoFile(null);
            setFormData((prev) => ({ ...prev, videoUrl: "" }));
          }}
        />
        <div className="flex justify-end">
          <button
            type="submit"
            className="px-6 py-2 bg-[#14251F] hover:bg-[#1f3a30] text-[#FFD1A0] rounded transition font-medium"
          >
            Save Changes
          </button>
        </div>
      </form>
    </div>
  );
};

export default AboutVideoAdmin;